export const getAllFlexboxVars = (attributes) => {
	const {
		displayType,
		flexDirectionDesktop,
		flexDirectionTablet,
		flexDirectionMobile,
		justifyContentDesktop,
		justifyContentTablet,
		justifyContentMobile,
		alignItemsDesktop,
		alignItemsTablet,
		alignItemsMobile,
		alignContentDesktop,
		alignContentTablet,
		alignContentMobile,
		flexWrapDesktop,
		flexWrapTablet,
		flexWrapMobile,
		rowGapDesktop,
		rowGapTablet,
		rowGapMobile,
		columnGapDesktop,
		columnGapTablet,
		columnGapMobile,
	} = attributes;

	const vars = {};

	// Display type (applies to all devices)
	if (displayType) {
		vars["--sfb-display"] = displayType;
	}

	// Helper to add CSS var if value exists
	const addVar = (varName, value) => {
		if (value) vars[varName] = value;
	};

	// Flex Direction
	addVar("--sfb-flex-direction-desktop", flexDirectionDesktop);
	addVar("--sfb-flex-direction-tablet", flexDirectionTablet);
	addVar("--sfb-flex-direction-mobile", flexDirectionMobile);

	// Justify Content
	addVar("--sfb-justify-content-desktop", justifyContentDesktop);
	addVar("--sfb-justify-content-tablet", justifyContentTablet);
	addVar("--sfb-justify-content-mobile", justifyContentMobile);

	// Align Items
	addVar("--sfb-align-items-desktop", alignItemsDesktop);
	addVar("--sfb-align-items-tablet", alignItemsTablet);
	addVar("--sfb-align-items-mobile", alignItemsMobile);

	// Align Content
	addVar("--sfb-align-content-desktop", alignContentDesktop);
	addVar("--sfb-align-content-tablet", alignContentTablet);
	addVar("--sfb-align-content-mobile", alignContentMobile);

	// Flex Wrap
	addVar("--sfb-flex-wrap-desktop", flexWrapDesktop);
	addVar("--sfb-flex-wrap-tablet", flexWrapTablet);
	addVar("--sfb-flex-wrap-mobile", flexWrapMobile);

	// Gap values (convert object to string with unit)
	const formatGap = (gapObj) => {
		if (!gapObj || typeof gapObj !== "object") return null;
		const { value, unit } = gapObj;
		return value ? `${value}${unit || "px"}` : null;
	};

	addVar("--sfb-row-gap-desktop", formatGap(rowGapDesktop));
	addVar("--sfb-row-gap-tablet", formatGap(rowGapTablet));
	addVar("--sfb-row-gap-mobile", formatGap(rowGapMobile));

	addVar("--sfb-column-gap-desktop", formatGap(columnGapDesktop));
	addVar("--sfb-column-gap-tablet", formatGap(columnGapTablet));
	addVar("--sfb-column-gap-mobile", formatGap(columnGapMobile));

	return vars;
};
